export default "__VITE_ASSET__1b8bd1fb__"